import { useFormik } from 'formik';
import * as Yup from 'yup';

const TRIGGER_TYPES = [
  { value: 'keyword', label: 'Keyword (parola chiave)' },
  { value: 'regex', label: 'Regex (espressione regolare)' },
  { value: 'all_messages', label: 'Tutti i messaggi' },
  { value: 'scheduled', label: 'Schedulato' },
];

const ACTION_TYPES = [
  { value: 'reply', label: 'Rispondi automaticamente' },
  { value: 'forward', label: 'Inoltra messaggio' },
];

export default function AutomationForm({ initial, onSave, onCancel }) {
  const formik = useFormik({
    initialValues: {
      name: initial?.name || '',
      trigger_type: initial?.trigger_type || 'keyword',
      trigger_value: initial?.trigger_value || '',
      action_type: initial?.action_type || 'reply',
      action_config: initial?.action_config || { reply_text: '' },
      is_active: initial?.is_active ?? true,
    },
    validationSchema: Yup.object({
      name: Yup.string().required('Nome richiesto'),
      trigger_type: Yup.string().required(),
      action_type: Yup.string().required(),
    }),
    onSubmit: onSave,
  });

  return (
    <form onSubmit={formik.handleSubmit} className="bg-surface rounded-lg border border-line p-6 max-w-lg space-y-4">
      <div>
        <label className="block text-sm font-medium text-ink mb-1">Nome</label>
        <input {...formik.getFieldProps('name')}
          className="w-full px-3 py-2 border border-line rounded-md text-sm focus:outline-none focus:ring-1 focus:ring-brand-500" />
        {formik.touched.name && formik.errors.name && <p className="text-xs text-danger mt-1">{formik.errors.name}</p>}
      </div>

      <div>
        <label className="block text-sm font-medium text-ink mb-1">Trigger</label>
        <select {...formik.getFieldProps('trigger_type')}
          className="w-full px-3 py-2 border border-line rounded-md text-sm focus:outline-none focus:ring-1 focus:ring-brand-500">
          {TRIGGER_TYPES.map((t) => <option key={t.value} value={t.value}>{t.label}</option>)}
        </select>
      </div>

      {formik.values.trigger_type !== 'all_messages' && (
        <div>
          <label className="block text-sm font-medium text-ink mb-1">
            {formik.values.trigger_type === 'keyword' ? 'Parole chiave (separate da virgola)' :
             formik.values.trigger_type === 'regex' ? 'Pattern regex' : 'Espressione cron'}
          </label>
          <input {...formik.getFieldProps('trigger_value')}
            className="w-full px-3 py-2 border border-line rounded-md text-sm focus:outline-none focus:ring-1 focus:ring-brand-500" />
        </div>
      )}

      <div>
        <label className="block text-sm font-medium text-ink mb-1">Azione</label>
        <select {...formik.getFieldProps('action_type')}
          className="w-full px-3 py-2 border border-line rounded-md text-sm focus:outline-none focus:ring-1 focus:ring-brand-500">
          {ACTION_TYPES.map((a) => <option key={a.value} value={a.value}>{a.label}</option>)}
        </select>
      </div>

      {formik.values.action_type === 'reply' && (
        <div>
          <label className="block text-sm font-medium text-ink mb-1">Testo risposta</label>
          <textarea value={formik.values.action_config.reply_text || ''}
            onChange={(e) => formik.setFieldValue('action_config', { reply_text: e.target.value })}
            rows={3}
            className="w-full px-3 py-2 border border-line rounded-md text-sm focus:outline-none focus:ring-1 focus:ring-brand-500" />
        </div>
      )}

      {formik.values.action_type === 'forward' && (
        <div>
          <label className="block text-sm font-medium text-ink mb-1">Inoltra a (numero WhatsApp)</label>
          <input value={formik.values.action_config.forward_to || ''}
            onChange={(e) => formik.setFieldValue('action_config', { forward_to: e.target.value })}
            className="w-full px-3 py-2 border border-line rounded-md text-sm focus:outline-none focus:ring-1 focus:ring-brand-500" />
        </div>
      )}

      <div className="flex items-center gap-2">
        <input type="checkbox" checked={formik.values.is_active}
          onChange={(e) => formik.setFieldValue('is_active', e.target.checked)}
          className="rounded border-line text-brand-700 focus:ring-brand-500" />
        <label className="text-sm text-ink">Attiva</label>
      </div>

      <div className="flex gap-3 pt-2">
        <button type="submit"
          className="px-4 py-2 bg-brand-600 text-white text-sm font-medium rounded-md hover:bg-brand-700 transition-colors">
          Salva
        </button>
        <button type="button" onClick={onCancel}
          className="px-4 py-2 border border-line text-ink text-sm rounded-md hover:bg-surface-2 transition-colors">
          Annulla
        </button>
      </div>
    </form>
  );
}
